export enum ReviewStatusEnum {
	Active = 1,
	Archived = 2,
	Deleted = 3,
	Inactive = 4,
}
